import type { Phrase } from '../types';

/** Strings for the venue area of the public site. Every key starts with `vn`. */
export const venueEn = {
  // page chrome
  vnBackToVenues: 'All venues',
  vnNotFoundTitle: 'We could not find this venue',
  vnNotFoundBody: 'It may have been removed, or it is not taking bookings right now.',
  vnBrowseVenues: 'Browse venues',
  vnSave: 'Save',
  vnSaved: 'Saved',

  // gallery
  vnViewAllPhotos: { one: 'View photo', other: 'View all {count} photos' },
  vnOpenPhoto: 'Open photo {index} of {count} of {name}',
  vnNoPhotos: 'The venue has not added photos yet',
  vnView360: '360° view',
  vn360Slide: '360° view · drag to look around',

  // header
  vnInBuilding: 'Part of {name}',
  vnCheckAvailability: 'Check availability',
  vnStatGuests: 'Guests',
  vnStatGuestsAll: 'guests in all',
  vnStatGuestsSplit: '{seated} seated · {standing} standing',
  vnStatFrom: 'Starting from',
  vnStatOnRequest: 'On request',
  vnStatRooms: 'Rooms',
  vnStatParking: 'Parking',
  vnStatNone: 'None listed',

  // section nav
  vnNavOverview: 'Overview',
  vnNavFacilities: 'Facilities',
  vnNavCapacity: 'Capacity',
  vnNavPricing: 'Pricing',
  vnNavLocation: 'Location',
  vnNavReviews: 'Reviews',

  // about
  vnAboutTitle: 'About the venue',
  vnAboutFallback: '{name} is a {category} with seating for {count} guests.',
  vnAboutFallbackPlace: '{name} is a {category} in {place} with seating for {count} guests.',
  vnGoodFor: 'Good for',
  vnGoodForNote: 'Events this kind of venue usually hosts. Ask the venue to confirm it suits yours.',

  // facilities
  vnFacilitiesTitle: 'What the venue offers',
  vnFacAc: 'Air conditioned',
  vnFacLift: 'Lift access',
  vnFacCatering: 'Catering: {value}',
  vnFacCuisine: 'Cuisine: {value}',
  vnFacEstablished: 'Established {year}',
  vnFacAmenities: 'Also at the venue',
  vnEquipTitle: 'Equipment provided for events',

  // capacity
  vnCapacityTitle: 'Space and seating',
  vnSeated: 'Seated',
  vnFloating: 'Floating / standing',
  vnTotalGuests: 'Total guest capacity',

  // pricing
  vnPricingTitle: 'Rates and terms',
  vnPerHour: 'Per hour',
  vnHalfDay: 'Session',
  vnFullDay: 'Full day',
  vnNotOffered: 'Not offered',
  vnWeekend: 'Weekend price (Sat & Sun)',
  vnWeekendVal: '{percent}% more than on weekdays',
  vnWeekendSame: 'Same rate every day',
  vnBuffer: 'Cleaning gap between bookings',
  vnBufferVal: { one: '{count} minute kept free', other: '{count} minutes kept free' },
  vnBufferHelp:
    'Kept free before and after every booking for cleaning and setup. The next booking can start only after this gap, so a slot right next to another booking cannot be booked.',
  vnBufferNone: 'No gap needed between bookings',
  vnPayVenue: 'You pay the venue directly. Nothing is paid on Aghosha.',
  vnVenueConfirms: 'The venue confirms every request before it becomes a booking.',
  vnExactPrice: 'The exact total for your date is shown as soon as you choose a time.',

  // availability panel
  vnAvailTitle: 'Check dates',
  vnAvailBody: 'Live availability. The price updates as you choose.',
  vnContinue: 'Continue to booking',
  vnLoginToContinue: 'Log in to continue',
  vnStaffNoBook: 'Venue staff accounts cannot request bookings. Log in with a guest account to book.',

  // location
  vnLocationTitle: 'Where it is',
  vnGetDirections: 'Get directions',
  vnOpensMaps: 'Opens Google Maps in a new tab',
  vnMapTitle: 'Map showing {name}',
  vnMapApprox: 'The venue has only given its town, so the map shows the area. Ask the venue for the exact location.',

  // reviews
  vnReviewsTitle: 'What guests say',
  vnBasedOn: { one: 'Based on {count} review', other: 'Based on {count} reviews' },
  vnNoReviewsBody: 'Guests can review the venue after their event.',

  // contact
  vnContactEyebrow: 'Contact',
  vnContactTitle: 'Questions before you book?',
  vnContactBody: 'Call or message the venue, or send an enquiry and they will get back to you.',
  vnEnquiryTitle: 'Send an enquiry',

  // related
  vnSameBuildingEyebrow: 'Same building',
  vnSimilarEyebrow: 'You may also like',
  // night edition
  vnBookingType: 'Booking type',
  vnCarPrev: 'Previous venues',
  vnCarNext: 'Next venues',
  vnEnqName: 'Your name',
  vnEnqPhone: 'Mobile number',
  vnEnqEmail: 'Email (optional)',
  vnEnqDate: 'Event date',
  vnEnqGuests: 'Guests',
  vnEnqGuestsPh: 'Approximate',
  vnEnqMessage: 'Message',
  vnEnqSentTitle: 'Enquiry sent',
  vnEnqSentBody: '{name} will reply by phone or SMS.',
  vnEnqAnother: 'Send another enquiry',
  vnReviewBy: 'Guest review',
} satisfies Record<string, Phrase>;
